import { render, staticRenderFns } from "./HomeDepartments.vue?vue&type=template&id=54bf29e8&scoped=true"
import script from "./HomeDepartments.vue?vue&type=script&lang=js"
export * from "./HomeDepartments.vue?vue&type=script&lang=js"
import style0 from "./HomeDepartments.vue?vue&type=style&index=0&id=54bf29e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bf29e8",
  null
  
)

export default component.exports